import { render, staticRenderFns } from "./Prazos.vue?vue&type=template&id=3352ed5a&"
import script from "./Prazos.vue?vue&type=script&lang=js&"
export * from "./Prazos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports